
  function fayaFallCountdown() {
    var now = new Date();
    var est = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));
    var midnight = new Date(est);
    midnight.setHours(24, 0, 0, 0);

    var diff = midnight - est;

    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById('faya-fall-hours').textContent = String(hours).padStart(2, '0');
    document.getElementById('faya-fall-minutes').textContent = String(minutes).padStart(2, '0');
    document.getElementById('faya-fall-seconds').textContent = String(seconds).padStart(2, '0');
  }

  function fayaFallResponsive() {
    var width = window.innerWidth;

    var bar = document.getElementById('faya-fall-bar');
    var inner = document.getElementById('faya-fall-inner');
    var title = document.getElementById('faya-fall-title');
    var subtitle = document.getElementById('faya-fall-subtitle');
    var timer = document.getElementById('faya-fall-timer');

    var numbers = document.querySelectorAll('.faya-fall-number');
    var labels = document.querySelectorAll('.faya-fall-label');
    var colons = document.querySelectorAll('.faya-fall-colon');
    var blocks = document.querySelectorAll('.faya-fall-block');

    if (width <= 390) {
      bar.style.padding = '7px 5px';
      inner.style.gap = '6px';

      title.style.fontSize = '11px';
      title.style.letterSpacing = '0px';

      subtitle.style.fontSize = '6.5px';
      subtitle.style.letterSpacing = '0.2px';

      timer.style.padding = '4px 6px 3px';
      timer.style.gap = '3px';

      numbers.forEach(function(el) { el.style.fontSize = '12px'; });
      labels.forEach(function(el) {
        el.style.fontSize = '5.5px';
        el.style.letterSpacing = '0.3px';
      });
      colons.forEach(function(el) {
        el.style.fontSize = '11px';
        el.style.marginBottom = '8px';
      });
      blocks.forEach(function(el) { el.style.minWidth = '20px'; });

    } else if (width <= 520) {
      bar.style.padding = '7px 7px';
      inner.style.gap = '8px';

      title.style.fontSize = '13px';
      title.style.letterSpacing = '0.1px';

      subtitle.style.fontSize = '7.5px';
      subtitle.style.letterSpacing = '0.4px';

      timer.style.padding = '4px 7px 3px';
      timer.style.gap = '4px';

      numbers.forEach(function(el) { el.style.fontSize = '13px'; });
      labels.forEach(function(el) {
        el.style.fontSize = '6px';
        el.style.letterSpacing = '0.4px';
      });
      colons.forEach(function(el) {
        el.style.fontSize = '12px';
        el.style.marginBottom = '9px';
      });
      blocks.forEach(function(el) { el.style.minWidth = '22px'; });

    } else {
      bar.style.padding = '8px 12px';
      inner.style.gap = '18px';

      title.style.fontSize = '18px';
      title.style.letterSpacing = '0.5px';

      subtitle.style.fontSize = '11px';
      subtitle.style.letterSpacing = '1.2px';

      timer.style.padding = '5px 13px 4px';
      timer.style.gap = '6px';

      numbers.forEach(function(el) { el.style.fontSize = '18px'; });
      labels.forEach(function(el) {
        el.style.fontSize = '8px';
        el.style.letterSpacing = '0.7px';
      });
      colons.forEach(function(el) {
        el.style.fontSize = '17px';
        el.style.marginBottom = '12px';
      });
      blocks.forEach(function(el) { el.style.minWidth = '28px'; });
    }
  }

  fayaFallCountdown();
  fayaFallResponsive();

  setInterval(fayaFallCountdown, 1000);
  window.addEventListener('resize', fayaFallResponsive);
